
import { Payload } from "@/types/profile";

export const networkPayloads: Payload[] = [
  // Content Caching payloads
  {
    id: "content-caching",
    name: "Content Caching",
    description: "Configure Content Caching settings",
    category: "Network",
    supportedPlatforms: ["macos"],
    configFields: [
      {
        id: "contentCachingEnabled",
        name: "Enable Content Caching",
        type: "boolean",
        required: true,
        default: false,
        description: "Enable content caching on the device"
      },
      {
        id: "cachingDataPath",
        name: "Caching Data Path",
        type: "text",
        required: false,
        description: "Path to store cached content"
      }
    ]
  },
  
  // DNS Proxy payloads
  {
    id: "dns-proxy",
    name: "DNS Proxy",
    description: "Configure DNS Proxy settings",
    category: "Network",
    supportedPlatforms: ["ios", "ipados", "macos"],
    configFields: [
      {
        id: "dnsProxyName",
        name: "DNS Proxy Name",
        type: "text",
        required: true,
        description: "Name for the DNS proxy configuration"
      },
      {
        id: "dnsProxyServer",
        name: "DNS Proxy Server",
        type: "text",
        required: true,
        description: "DNS proxy server address"
      }
    ]
  },
  
  // Global HTTP Proxy payloads
  {
    id: "global-http-proxy",
    name: "Global HTTP Proxy",
    description: "Configure global HTTP proxy settings",
    category: "Network",
    supportedPlatforms: ["ios", "ipados", "tvos"],
    configFields: [
      {
        id: "proxyType",
        name: "Proxy Type",
        type: "select",
        required: true,
        options: ["Manual", "Auto"],
        default: "Manual",
        description: "Type of proxy configuration"
      },
      {
        id: "proxyServer",
        name: "Proxy Server",
        type: "text",
        required: true,
        description: "Proxy server address"
      },
      {
        id: "proxyPort",
        name: "Proxy Port",
        type: "number",
        required: true,
        default: 8080,
        description: "Proxy server port"
      }
    ]
  },
  
  // VPN payloads
  {
    id: "vpn",
    name: "VPN",
    description: "Configure VPN settings for devices",
    category: "Network",
    supportedPlatforms: ["macos", "ios", "ipados"],
    configFields: [
      {
        id: "vpnType",
        name: "VPN Type",
        type: "select",
        required: true,
        options: ["IKEv2", "IPSec", "L2TP", "PPTP"],
        default: "IKEv2",
        description: "Type of VPN connection"
      },
      {
        id: "server",
        name: "Server",
        type: "text",
        required: true,
        description: "VPN server address"
      },
      {
        id: "account",
        name: "Account",
        type: "text",
        required: true,
        description: "VPN account name"
      },
      {
        id: "password",
        name: "Password",
        type: "text",
        required: false,
        description: "VPN password"
      },
      {
        id: "onDemandEnabled",
        name: "Connect On Demand",
        type: "boolean",
        required: false,
        default: false,
        description: "Connect to VPN automatically when needed"
      }
    ]
  },
  
  // Wi-Fi payloads
  {
    id: "wifi",
    name: "Wi-Fi",
    description: "Configure Wi-Fi settings for devices",
    category: "Network",
    supportedPlatforms: ["macos", "ios", "ipados", "tvos"],
    configFields: [
      {
        id: "ssid",
        name: "SSID",
        type: "text",
        required: true,
        description: "Wi-Fi network name"
      },
      {
        id: "password",
        name: "Password",
        type: "text",
        required: false,
        description: "Wi-Fi network password"
      },
      {
        id: "security",
        name: "Security Type",
        type: "select",
        required: true,
        options: ["None", "WEP", "WPA", "WPA2", "WPA3"],
        default: "WPA2",
        description: "Wi-Fi security type"
      },
      {
        id: "hidden",
        name: "Hidden Network",
        type: "boolean",
        required: false,
        default: false,
        description: "Connect to hidden network"
      },
      {
        id: "autoJoin",
        name: "Auto Join",
        type: "boolean",
        required: false,
        default: true,
        description: "Automatically join this network"
      }
    ]
  }
];
